<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-row>
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-col :span="10">
              <el-form-item label="线路" prop="startDot">
                <el-cascader
                  :filterable="true"
                  :clearable="true"
                  key="el2"
                  style="width: 100%"
                  :options="options"
                  ref="cascaderStart"
                  v-model="form.startDot"
                  @change="handleChangeStart"
                  :props="cityProps"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="4" class="arrow-box">
              <el-image :src="arrowImage" class="arrow-img"></el-image>
            </el-col>
            <el-col :span="10" style="padding-top: 0.3rem">
              <el-form-item prop="endDot">
                <el-cascader
                  :filterable="true"
                  :clearable="true"
                  key="el3"
                  style="width: 100%"
                  :options="options"
                  ref="cascaderEnd"
                  @change="handleChangeEnd"
                  v-model="form.endDot"
                  :props="cityProps"></el-cascader>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { addInfo, editInfo } from "./api";
import { getAreaNext } from "@/views/commonApi";
import { setAreaTree } from "@/utils";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      loading: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "添加/编辑线路",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      cityProps: {
        value: "areaCode",
        label: "areaName",
        checkStrictly: true,
      },
      // city1Props: {
      //   lazy: true,
      //   checkStrictly: true, //可选择任意节点
      //   lazyLoad(node, resolve) {
      //     // setTimeout(() => {
      //     const nodes = [];
      //     let query = {};
      //     // 构造查询条件
      //     if (node.value) {
      //       query = {
      //         code: node.value,
      //       };
      //     }
      //     //查询接口
      //     getAreaNext(query).then((res) => {
      //       res.data.map((item) => {
      //         let obj = {
      //           value: item.areaCode,
      //           label: item.areaName,
      //           leaf: item.areaLevel === 1,
      //           disabled: item.areaLevel <= 0,
      //         };
      //         nodes.push(obj);
      //       });
      //       //重新加载节点
      //       resolve(nodes);
      //     });
      //     // }, 500);
      //   },
      // },
      // city2Props: {
      //   lazy: true,
      //   checkStrictly: true, //可选择任意节点
      //   lazyLoad(node, resolve) {
      //     // setTimeout(() => {
      //     const nodes = [];
      //     let query = {};
      //     // 构造查询条件
      //     if (node.value) {
      //       query = {
      //         code: node.value,
      //       };
      //     }
      //     //查询接口
      //     getAreaNext(query).then((res) => {
      //       res.data.map((item) => {
      //         let obj = {
      //           value: item.areaCode,
      //           label: item.areaName,
      //           leaf: item.areaLevel === 1,
      //           disabled: item.areaLevel <= 0,
      //         };
      //         nodes.push(obj);
      //       });
      //       //重新加载节点
      //       resolve(nodes);
      //     });
      //     // }, 500);
      //   },
      // },
      form: {
        lineId: "",
        endCityCode: "",
        endCityName: "",
        endProvinceCode: "",
        endProvinceName: "",
        startCityCode: "",
        startCityName: "",
        startProvinceCode: "",
        startProvinceName: "",
        startDot: [],
        endDot: [],
      },
      rules: {
        startDot: [{ required: true, message: "线路起点不能为空" }],
        endDot: [{ required: true, message: "线路终点不能为空" }],
        companyIds: [{ required: true, message: "公司不能为空" }],
      },
      arrowImage: require("@/assets/imgs/arroy.png"),
      companyList: [],
    };
  },
  computed: {
    options: function() {
      let treeData = JSON.parse(localStorage.getItem("area")) || []
      return setAreaTree(treeData, 1, 2)
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleChangeStart() {
      // 可以通过 this.$refs.cascader.getCheckedNodes() 获取选中的节点信息
      this.form.startProvinceCode = "";
      this.form.startProvinceName = "";
      this.form.startCityCode = "";
      this.form.startCityName = "";
      const nodes = this.$refs.cascaderStart.getCheckedNodes();
      nodes[0].pathNodes.forEach((node, index) => {
        if (index === 0) {
          this.form.startProvinceCode = node.value;
          this.form.startProvinceName = node.label;
        } else if (index === 1) {
          this.form.startCityCode = node.value;
          this.form.startCityName = node.label;
        }
      });
      // // console.log("选中的名称start:", this.start);
    },
    handleChangeEnd() {
      // 可以通过 this.$refs.cascader.getCheckedNodes() 获取选中的节点信息
      this.form.endProvinceCode = "";
      this.form.endProvinceName = "";
      this.form.endCityCode = "";
      this.form.endCityName = "";
      const nodes = this.$refs.cascaderEnd.getCheckedNodes();
      nodes[0].pathNodes.forEach((node, index) => {
        if (index === 0) {
          this.form.endProvinceCode = node.value;
          this.form.endProvinceName = node.label;
        } else if (index === 1) {
          this.form.endCityCode = node.value;
          this.form.endCityName = node.label;
        }
      });
      // // console.log("选中的名称end:", this.end);
    },
    getDetail(lineId) {
      this.loading = true;
      detailInfo(lineId)
        .then((res) => {
          if (res.code === 200) {
            let arr1 = [res.data.startProvinceCode, res.data.startCityCode];
            let arr2 = [res.data.endProvinceCode, res.data.endCityCode];
            this.form.startDot = [...arr1];
            this.form.endDot = [...arr2];
            this.form.lineId = res.data.lineId;
            // this.form.deptIds = res.data.deptFullPath.split(",");
            // this.form.deptId = res.data.deptId;
            // this.form.deptName = res.data.deptName;
            this.form.endCityCode = res.data.endCityCode;
            this.form.endCityName = res.data.endCityName;
            this.form.endProvinceCode = res.data.endProvinceCode;
            this.form.endProvinceName = res.data.endProvinceName;
            this.form.startCityCode = res.data.startCityCode;
            this.form.startCityName = res.data.startCityName;
            this.form.startProvinceCode = res.data.startProvinceCode;
            this.form.startProvinceName = res.data.startProvinceName;

            // // console.log(this.form);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    init(row) {
      if (!!row) {
        let arr1 = [row.startProvinceCode, row.startCityCode];
        let arr2 = [row.endProvinceCode, row.endCityCode];
        this.form.startDot = [...arr1];
        this.form.endDot = [...arr2];
        this.form.lineId = row.lineId;
        this.form.endCityCode = row.endCityCode;
        this.form.endCityName = row.endCityName;
        this.form.endProvinceCode = row.endProvinceCode;
        this.form.endProvinceName = row.endProvinceName;
        this.form.startCityCode = row.startCityCode;
        this.form.startCityName = row.startCityName;
        this.form.startProvinceCode = row.startProvinceCode;
        this.form.startProvinceName = row.startProvinceName;
        this.dialogObj.title = "编辑线路";
      } else {
        this.dialogObj.title = "添加线路";
      }
      this.dialogObj.show = true;
    },

    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let methodName = "";
          if (this.form.lineId) {
            methodName = editInfo;
          } else {
            methodName = addInfo;
          }
          const par = {
            lineId: this.form.lineId,
            endCityCode: this.form.endCityCode,
            endCityName: this.form.endCityName,
            endProvinceCode: this.form.endProvinceCode,
            endProvinceName: this.form.endProvinceName,
            startCityCode: this.form.startCityCode,
            startCityName: this.form.startCityName,
            startProvinceCode: this.form.startProvinceCode,
            startProvinceName: this.form.startProvinceName
          };
          methodName(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success(
                  this.form.lineId ? "编辑成功" : "保存成功"
                );
                this.$parent.handleAddOrEditSuccess(
                  this.form.lineId ? "edit" : "add"
                );
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .arrow-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .arrow-img {
    width: 0.48rem;
    height: 0.05rem;
    position: relative;
    top: 0.45rem;
  }
}
</style>
